import { useCallback } from "react"
import { useSignal } from "@preact/signals-react"
import { useToast } from "@hooks"
import { strategiesApi } from "Pages/DsRepricing/Page/@services/api"
import { forClone } from "Pages/DsRepricing/Page/@services/adapters"
import { dsRepricingDrawerData, dsRepricingOriginalData } from "Pages/DsRepricing/Page/@signals"

export default function useDsRepricingClone(id) {
	const { showToast } = useToast()
	const isLoading = useSignal(false)

	const onClone = useCallback(() => {
		isLoading.value = true
		strategiesApi.get(id)
			.then(row => {
				// `forClone` drops the id, the name and everything the server owns,
				// so saving performs a create.
				dsRepricingDrawerData.value = forClone(row)
				dsRepricingOriginalData.value = null
				isLoading.value = false
				// An exact copy meets the original on every axis at the same priority, so it
				// would be rejected on save. Warned here instead of at the end.
				showToast.warning(
					"Cloned. Change the period, offices, ACRISS, duration, tariff type, insurance or priority before saving — an exact copy overlaps the original strategy."
				)
			})
			.catch(err => {
				isLoading.value = false
				showToast.error(err?.message || "Error cloning the strategy")
			})
	}, [id])

	return { onClone, isLoading: isLoading.value }
}
